import { isAxiosError } from 'axios';

const SAFE_CODES = ['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_CANCELED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST'] as const;
type WalletReadCode = typeof SAFE_CODES[number];

export interface WalletReadFailure {
  kind: 'authentication_required' | 'forbidden' | 'server' | 'http' | 'timeout' | 'cancelled' | 'transport' | 'unknown';
  status: number | null;
  code: WalletReadCode | null;
}

// Build a fresh allowlisted record: Axios errors can contain credentials and customer data.
export function classifyWalletReadFailure(error: unknown): WalletReadFailure {
  if (!isAxiosError(error)) return { kind: 'unknown', status: null, code: null };
  const responseStatus = error.response?.status;
  const status = typeof responseStatus === 'number' && Number.isInteger(responseStatus)
    && responseStatus >= 100 && responseStatus <= 599 ? responseStatus : null;
  const code = SAFE_CODES.find((candidate) => candidate === error.code) ?? null;
  let kind: WalletReadFailure['kind'];
  if (status === 401) kind = 'authentication_required';
  else if (status === 403) kind = 'forbidden';
  else if (status !== null) kind = status >= 500 ? 'server' : 'http';
  else if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') kind = 'timeout';
  else if (code === 'ERR_CANCELED') kind = 'cancelled';
  else kind = 'transport';
  return { kind, status, code };
}
